export const floorPlanComparisonKeys = {
  all: ["quantitySurveyorFloorPlanComparisons"] as const,
  detail: (baseFloorPlanId: number) =>
    [...floorPlanComparisonKeys.all, baseFloorPlanId] as const,
};
